/* Presentation only: no cart handlers, no autoplay, no dependency on motion. */
(() => {
  if (window.bazV4HomeReady) return;
  window.bazV4HomeReady = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const selector = '.b4h-heading, .b4h-product, .b4h-duo-card, .b4h-guide-card';
  const reveal = element => element.classList.remove('b4h-enter-pending');
  const init = (root = document) => {
    if (document.body.dataset.b4Motion === 'false' || reduce.matches || !('IntersectionObserver' in window)) {
      document.querySelectorAll('.b4h-enter-pending').forEach(reveal);
      return;
    }
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      reveal(entry.target);
      observer.unobserve(entry.target);
    }), { threshold: 0.02, rootMargin: '0px 0px -16px 0px' });
    root.querySelectorAll(selector).forEach(element => {
      const section = element.closest('.b4-home');
      if (!section || section.dataset.b4hMotion !== 'true' || element.dataset.b4hReady) return;
      element.dataset.b4hReady = 'true';
      if (element.getBoundingClientRect().top < window.innerHeight) return;
      element.classList.add('b4h-enter', 'b4h-enter-pending');
      observer.observe(element);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const element = event.target.closest('.b4h-enter-pending');
    if (element) reveal(element);
  });
  document.addEventListener('focusin', event => {
    const element = event.target.closest?.('.b4h-enter-pending');
    if (element) reveal(element);
  });
  reduce.addEventListener?.('change', event => {
    if (event.matches) document.querySelectorAll('.b4h-enter-pending').forEach(reveal);
  });
})();

(() => {
  if (window.bazV4CardVariantsReady) return;
  window.bazV4CardVariantsReady = true;

  const cardSelector = 'product-card, .b4h-product';
  const linkSelector = [
    '[ref="productCardLink"]',
    '[ref="productTitleLink"]',
    '[ref="cardGalleryLink"]',
    '.b4h-product-image',
    '.b4h-product-details h3 a',
    '.b4h-product-action',
  ].join(',');

  const updateLinks = (card, url) => {
    if (!url) return;
    card.querySelectorAll(linkSelector).forEach(link => {
      if (link instanceof HTMLAnchorElement) link.href = url;
    });
  };

  const updateNativePrice = (card, button) => {
    const container = card.querySelector('product-price [ref="priceContainer"]');
    const html = button.dataset.priceHtml;
    if (!container || !html) return;
    container.innerHTML = html;
  };

  const updateHomePrice = (card, button) => {
    const price = card.querySelector('.b4h-product-price');
    if (!price) return;
    price.textContent = '';

    const current = document.createElement('span');
    current.textContent = button.dataset.priceText || '';
    price.append(current);

    if (button.dataset.saleActive === 'true' && button.dataset.compareText) {
      const compare = document.createElement('s');
      compare.textContent = button.dataset.compareText;
      price.append(compare);
    }
  };

  const updateBadges = (card, button) => {
    const hasSale = button.dataset.saleActive === 'true';
    card.querySelectorAll('[data-b4-sale-badge]').forEach(badge => {
      if (!(badge instanceof HTMLElement)) return;
      const nativeBadgeWrapper = badge.closest('.product-badges');
      if (hasSale && button.dataset.badgeText) {
        badge.textContent = button.dataset.badgeText;
        badge.hidden = false;
        badge.style.removeProperty('display');
        badge.removeAttribute('aria-hidden');
        if (nativeBadgeWrapper instanceof HTMLElement) {
          nativeBadgeWrapper.hidden = false;
          nativeBadgeWrapper.style.removeProperty('display');
          nativeBadgeWrapper.removeAttribute('aria-hidden');
        }
      } else {
        badge.textContent = '';
        badge.hidden = true;
        badge.style.display = 'none';
        badge.setAttribute('aria-hidden', 'true');
        if (nativeBadgeWrapper instanceof HTMLElement) {
          nativeBadgeWrapper.hidden = true;
          nativeBadgeWrapper.style.display = 'none';
          nativeBadgeWrapper.setAttribute('aria-hidden', 'true');
        }
      }
    });
  };

  const updateImage = (card, button) => {
    const imageUrl = button.dataset.variantImage;
    if (!imageUrl) return;

    const image = card.querySelector('.b4h-product-primary, .card-gallery img.product-media__image, .card-gallery img');
    if (!(image instanceof HTMLImageElement)) return;

    image.src = imageUrl;
    if (button.dataset.variantSrcset) image.srcset = button.dataset.variantSrcset;
    if (button.dataset.variantAlt) image.alt = button.dataset.variantAlt;

    const media = image.closest('[data-media-id]');
    if (media instanceof HTMLElement && button.dataset.variantMediaId) {
      media.dataset.mediaId = button.dataset.variantMediaId;
    }
  };

  const selectButton = button => {
    const card = button.closest(cardSelector);
    if (!card) return;

    const group = button.closest('.b4-product-card-sizes');
    group?.querySelectorAll('[data-b4-card-variant]').forEach(option => {
      const active = option === button;
      option.classList.toggle('is-selected', active);
      option.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    updateLinks(card, button.dataset.variantUrl);
    updateNativePrice(card, button);
    updateHomePrice(card, button);
    updateBadges(card, button);
    updateImage(card, button);
  };

  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-b4-card-variant]');
    if (!(button instanceof HTMLElement)) return;
    event.preventDefault();
    event.stopPropagation();
    if (button.getAttribute('aria-disabled') === 'true') return;
    selectButton(button);
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const button = event.target.closest?.('[data-b4-card-variant]');
    if (!(button instanceof HTMLElement)) return;
    event.preventDefault();
    if (button.getAttribute('aria-disabled') === 'true') return;
    selectButton(button);
  });
})();
